// 'version' is used in cypress.config.js. If you need to misplace it please update the file accordingly.
export const version = '1.3'
export const lastUpdated = 'April, 2025'
